module.exports = __webpack_public_path__ + "media/Spectrum - Keys.3a6a38ea.mp4";